// Teal Professional design
const TealProfessionalDesign = {
  id: 'teal-professional',
  name: 'Teal',
  category: 'professional',
  description: 'Cool and sophisticated teal with grey undertones',
  colors: {
    primary: "#008080",    // Teal
    secondary: "#4682B4",  // Steel Blue (complementary)
    tertiary: "#B0C4DE",   // Light Steel Blue
    quaternary: "#F0F8FF", // Alice Blue (very light)
    accent1: "#008080",    // Teal
    accent2: "#4682B4",    // Steel Blue
    // Add other accents if needed
    text: "#2F4F4F",       // Dark Slate Gray Text
    textSecondary: "#708090", // Slate Gray Secondary Text
    background: "#ffffff", // White background
    sidebarBackground: "#F0F8FF", // Alice Blue sidebar
    border: "#ffffff",     // Light Steel Blue border
  },
};

export default TealProfessionalDesign; 